import { render, staticRenderFns } from "./SensorsChoice.vue?vue&type=template&id=287209aa&scoped=true"
import script from "./SensorsChoice.vue?vue&type=script&lang=ts"
export * from "./SensorsChoice.vue?vue&type=script&lang=ts"
import style0 from "./SensorsChoice.vue?vue&type=style&index=0&id=287209aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287209aa",
  null
  
)

export default component.exports